var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimbukdoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.202,
    height: 31.673,
    viewBox: "0 0 127.202 31.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.257,
    y1: 0.5,
    x2: 13.595,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#eda021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#e79f2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#d79b44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#bc9667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#948f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#5a86b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#2b83c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#36579e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393086"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3.572,
    y1: 0.5,
    x2: 28.785,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.21,
    y1: 0.5,
    x2: 25.983,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.142,
    y1: 0.5,
    x2: 4.858,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.977,
    y1: 0.5,
    x2: 5.695,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.844,
    y1: 0.5,
    x2: 6.18,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -4.708,
    y1: 0.5,
    x2: 6.021,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -5.982,
    y1: 0.5,
    x2: 4.978,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -6.277,
    y1: 0.5,
    x2: 3.414,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -6.394,
    y1: 0.5,
    x2: 2.05,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -8.524,
    y1: 0.5,
    x2: 1.093,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-5.347 -4.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6453",
    "data-name": "Group 6453",
    transform: "translate(5.347 4.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6451",
    "data-name": "Group 6451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6450",
    "data-name": "Group 6450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14943",
    "data-name": "Path 14943",
    d: "M47.979,52.459c-.6,1.711-2.231,5.822-3.574,5.711-.835-.07-.839-1.724-.839-2.293v-.164a28.254,28.254,0,0,1,1.208-6.85.826.826,0,0,0,.02-.221c0-.7-1-1.4-1.7-1.625a1.33,1.33,0,0,0-.364-.057,1.091,1.091,0,0,0-1.044.774l-.291,1.032a27.778,27.778,0,0,0-1.122,7.1l.033.9c.09,1.638.823,4.176,2.461,4.442a2.423,2.423,0,0,0,.442.029h.041c3.1,0,4.639-5.171,5.04-6.9.262-1.134.332-1.437.373-1.777C48.721,52.016,48.16,51.939,47.979,52.459Z",
    transform: "translate(-25.972 -29.568)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14944",
    "data-name": "Path 14944",
    d: "M48.11,36.02a2.226,2.226,0,0,1,.111-.7,2.124,2.124,0,0,1,2-1.715,1.722,1.722,0,0,1,1.744,1.687,2.393,2.393,0,0,1-.479,1.38,2.151,2.151,0,0,1-1.744,1.069A1.654,1.654,0,0,1,48.11,36.02Z",
    transform: "translate(-30.602 -21.678)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14945",
    "data-name": "Path 14945",
    d: "M38.37,7.256a2.539,2.539,0,0,1,.127-.807A2.441,2.441,0,0,1,40.79,4.48a1.977,1.977,0,0,1,2,1.937A2.794,2.794,0,0,1,42.243,8a2.477,2.477,0,0,1-2,1.228A1.9,1.9,0,0,1,38.37,7.256Z",
    transform: "translate(-24.85 -4.48)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14946",
    "data-name": "Path 14946",
    d: "M31.523,17.7a1.359,1.359,0,0,0-1.105-.721,1.4,1.4,0,0,0-.184.016c-.581.111-.835.651-1.06,1.126a3.743,3.743,0,0,1-.336.61,2.221,2.221,0,0,1-1.9.692c-.217,0-.43-.012-.639-.029-1.552-.131-3.116-.381-4.631-.622-1.3-.209-2.645-.426-3.98-.565a26.989,26.989,0,0,0-2.768-.151c-.643,0-1.273.029-1.871.086A11.543,11.543,0,0,0,8.39,19.449,6.053,6.053,0,0,0,5.569,22.61,3.892,3.892,0,0,0,7.006,27.15a2.093,2.093,0,0,0,1.028.307,1.278,1.278,0,0,0,.671-.18,1.792,1.792,0,0,0,.442-2.2c-.082-.209-.18-.414-.274-.618a3.428,3.428,0,0,1-.426-1.3,2.085,2.085,0,0,1,.839-1.63,4.99,4.99,0,0,1,1.818-.835,13.146,13.146,0,0,1,3.488-.467,13.536,13.536,0,0,1,2.158.176c-.033.1-.066.192-.1.291h-.008a64.477,64.477,0,0,0-2.936,9.916,28.078,28.078,0,0,0-.643,9.916,3.784,3.784,0,0,0,.659,1.863,3.9,3.9,0,0,0,2.792,1.13,1.745,1.745,0,0,0,.209.008.806.806,0,0,0,.811-.4.933.933,0,0,0-.111-.839c-1.228-2.444-1.024-5.429-.712-7.759a69.264,69.264,0,0,1,3.329-13.093l.188-.528h.008c.016-.049.033-.1.045-.156a38.383,38.383,0,0,0,7.046.868,5.676,5.676,0,0,0,3.243-.77A2.492,2.492,0,0,0,31.523,17.7Z",
    transform: "translate(-5.347 -11.862)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6452",
    "data-name": "Group 6452",
    transform: "translate(22 13.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14947",
    "data-name": "Path 14947",
    d: "M59.08,61.5V49.2h3.656v.79a4.6,4.6,0,0,1,2.981-1.024,4.552,4.552,0,0,1,2.031.442,4.112,4.112,0,0,1,1.511,1.257,4.968,4.968,0,0,1,1.716-1.257,5.268,5.268,0,0,1,2.166-.442,4.529,4.529,0,0,1,2.391.626,4.456,4.456,0,0,1,1.638,1.744,5.355,5.355,0,0,1,.6,2.579V61.5H74.114V54.432a2.364,2.364,0,0,0-.532-1.625,1.789,1.789,0,0,0-1.413-.606,2.571,2.571,0,0,0-1.105.233,2.325,2.325,0,0,0-.856.7c.016.123.025.254.033.385s.012.266.012.405V61.5H66.6V54.432a2.363,2.363,0,0,0-.532-1.625,1.788,1.788,0,0,0-1.413-.606,2.607,2.607,0,0,0-1.093.221,2.144,2.144,0,0,0-.823.663V61.5Z",
    transform: "translate(-59.08 -44.646)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14948",
    "data-name": "Path 14948",
    d: "M110.46,56.1V39.83h7.832a6.591,6.591,0,0,1,2.854.581,4.69,4.69,0,0,1,1.928,1.617,4.142,4.142,0,0,1,.7,2.383,3.782,3.782,0,0,1-.483,1.871,4.555,4.555,0,0,1-1.322,1.478,4.7,4.7,0,0,1,1.683,1.511,3.609,3.609,0,0,1,.622,2.047,4.488,4.488,0,0,1-.7,2.5,4.7,4.7,0,0,1-1.965,1.687,6.761,6.761,0,0,1-2.936.606H110.46Zm3.881-9.785h3.7a1.964,1.964,0,0,0,1.355-.442,1.627,1.627,0,0,0,0-2.338,2,2,0,0,0-1.355-.43h-3.7Zm0,6.51h4.041a2.089,2.089,0,0,0,1.433-.467,1.75,1.75,0,0,0,0-2.514,2.089,2.089,0,0,0-1.433-.467h-4.041Z",
    transform: "translate(-89.424 -39.249)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14949",
    "data-name": "Path 14949",
    d: "M152.866,62.068a4.817,4.817,0,0,1-2.473-.626,4.429,4.429,0,0,1-1.683-1.756,5.333,5.333,0,0,1-.61-2.567V49.54h3.656v7.067a2.234,2.234,0,0,0,.6,1.617,2.088,2.088,0,0,0,1.568.614,2.907,2.907,0,0,0,1.241-.254,2.426,2.426,0,0,0,.9-.721V49.54h3.656v12.3h-3.656V61A4.989,4.989,0,0,1,152.866,62.068Z",
    transform: "translate(-111.653 -44.983)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14950",
    "data-name": "Path 14950",
    d: "M187,61.738a6.286,6.286,0,0,1-3.218-.835,6.176,6.176,0,0,1-2.268-2.289,6.736,6.736,0,0,1,0-6.5,6.268,6.268,0,0,1,2.268-2.289A6.2,6.2,0,0,1,187,48.98a6.752,6.752,0,0,1,2.8.594,6.268,6.268,0,0,1,2.256,1.687l-2.235,2.4a4.4,4.4,0,0,0-1.286-1.081,3.105,3.105,0,0,0-1.445-.336,2.561,2.561,0,0,0-1.421.405,2.824,2.824,0,0,0-.995,1.114,3.5,3.5,0,0,0-.36,1.617,3.36,3.36,0,0,0,.373,1.593,2.879,2.879,0,0,0,1.028,1.118,2.723,2.723,0,0,0,1.466.405,2.961,2.961,0,0,0,1.376-.323,4.194,4.194,0,0,0,1.22-1l2.166,2.326a6.233,6.233,0,0,1-2.211,1.662A6.659,6.659,0,0,1,187,61.738Z",
    transform: "translate(-130.894 -44.652)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14951",
    "data-name": "Path 14951",
    d: "M211.72,55.262V38.991l3.656-.581v9.576l4.762-5.02h4.086l-5.306,5.556,5.666,6.739h-4.627l-4.581-5.507v5.507Z",
    transform: "translate(-149.225 -38.41)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14952",
    "data-name": "Path 14952",
    d: "M245.07,56.1V39.83h6.412a8.451,8.451,0,0,1,3.271.626,8.3,8.3,0,0,1,2.653,1.744,8.2,8.2,0,0,1,1.785,2.6,7.964,7.964,0,0,1,.643,3.206,7.75,7.75,0,0,1-.643,3.161,8.022,8.022,0,0,1-1.785,2.567,8.4,8.4,0,0,1-5.924,2.358H245.07Zm3.881-3.533h2.436a4.272,4.272,0,0,0,1.728-.348,4.476,4.476,0,0,0,2.362-2.428,4.641,4.641,0,0,0,.34-1.777,4.909,4.909,0,0,0-.34-1.826,4.492,4.492,0,0,0-2.362-2.465,4.134,4.134,0,0,0-1.728-.36h-2.436Z",
    transform: "translate(-168.921 -39.249)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14953",
    "data-name": "Path 14953",
    d: "M290.851,61.738a6.467,6.467,0,0,1-3.3-.848A6.362,6.362,0,0,1,285.23,58.6a6.192,6.192,0,0,1-.86-3.23,6.256,6.256,0,0,1,.86-3.243,6.332,6.332,0,0,1,2.326-2.3,6.832,6.832,0,0,1,6.592,0,6.331,6.331,0,0,1,2.326,2.3,6.256,6.256,0,0,1,.86,3.243,6.191,6.191,0,0,1-.86,3.23,6.361,6.361,0,0,1-2.326,2.289A6.478,6.478,0,0,1,290.851,61.738Zm0-3.255a2.716,2.716,0,0,0,1.49-.418,3.017,3.017,0,0,0,1.036-1.126,3.437,3.437,0,0,0,0-3.161,2.983,2.983,0,0,0-1.048-1.126,2.824,2.824,0,0,0-2.956,0,2.983,2.983,0,0,0-1.048,1.126,3.262,3.262,0,0,0-.385,1.593,3.212,3.212,0,0,0,.385,1.568,2.983,2.983,0,0,0,1.048,1.126A2.714,2.714,0,0,0,290.851,58.483Z",
    transform: "translate(-192.13 -44.652)",
    fill: "url(#linear-gradient-11)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimbukdoLogo);
export default __webpack_public_path__ + "static/media/timbukdo-logo.c70d5f66.svg";
export { ForwardRef as ReactComponent };